import { t } from './lang/trans.js';

export const  zpad = num => ('00' + num).slice(-2);

export function timeToSeconds(time) {
  const [hours, minutes] = time.split(/:/);
  return parseInt(hours) * 3600 + parseInt(minutes) * 60;
}

export function secondsToTime(seconds) {
  if(seconds < 0) {
    seconds += 86400;
  }
  const num = parseInt(seconds);
  const hours = zpad(Math.floor(num / 3600));
  const minutes = zpad(Math.floor(Math.floor(num % 3600) / 60), 2);
  return `${hours}:${minutes}`
}

export function timeDiff(from, to) {
  const seconds = timeToSeconds(to) - timeToSeconds(from);
  return (seconds < 0 ? seconds + 86400 : seconds);
}

export function secondsToDuration(seconds) {
  const minutes = Math.floor(seconds / 60);
  if(seconds < 3600) {
    return `${minutes} min`;
  } else {
    return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
  }
}

export function timeSubtractSeconds(time, seconds) {
  return secondsToTime(
    timeToSeconds(time) - seconds
  );
}

export function dateStringToFriendly(dateString) {
  const day  = dateString.slice(6).replace(/^0/, '');
  const month = dateString.slice(4, 6).replace(/^0/, '');

  const months = {
    '1': 'january',
    '2': 'february',
    '3': 'march',
    '4': 'april',
    '5': 'may',
    '6': 'june',
    '7': 'july',
    '8': 'august',
    '9': 'september',
    '10': 'october',
    '11': 'november',
    '12': 'december'
  }

  if(t('DATE_BEFORE_MONTH')) {
    return `${day} ${t(months[month])}`;
  } else {
    return `${t(months[month])} ${day}`;
  }
}

export function dateStringToDay(dateString) {
  const day  = parseInt(dateString.slice(6).replace(/^0/, ''), 10);
  const month = parseInt(dateString.slice(4, 6).replace(/^0/, ''), 10);

  return month * 31 + day;
}

export const normalize = str => str.
  toLowerCase().
  replace(/â/g, 'a').
  replace(/ş/g, 's').
  replace(/ă/g, 'a').
  replace(/ţ/g, 't').
  replace(/î/g, 'i').
  replace(/\s+/g, '');

export const normalizeMulti = str => {
  const preNormalized = str.
    toLowerCase().
    replace(/ş/g, 's').
    replace(/ă/g, 'a').
    replace(/ţ/g, 't').
    replace(/\s+/g, '');
  return [
    preNormalized.replace(/â/g, 'a').replace(/î/g, 'a'),
    preNormalized.replace(/â/g, 'i').replace(/î/g, 'i')
  ]
}

export const moneyFormat = amount => {
  const fraction = (Math.round((amount - Math.floor(amount)) * 10) + '').slice(0, 1).replace(/0+$/, '');
  return `${Math.floor(amount)}${fraction ? '.' + fraction : ''}`;
}

export const cleanStationNameForInfofer = name => {
  return (name + '').
    replace(/â/g, 'a').
    replace(/ş/g, 's').
    replace(/ă/g, 'a').
    replace(/ţ/g, 't').
    replace(/\./g, '').
    replace(/î/g, 'i');
};

export const isTimeBeforeNow = time => {
  const timeInSeconds = timeToSeconds(time);
  const now = new Date();
  const nowInSeconds = now.getHours() * 3600 + now.getMinutes() * 60;
  return timeInSeconds < nowInSeconds;
}



/** WEBPACK FOOTER **
 ** ./src/utils.js
 **/